import { PublicLayout } from '../layout/PublicLayout';
import { useSEO } from '@/hooks/useSEO';
import { LEGAL_CONFIG, LEGAL_ROUTES } from './legalConfig';

export const ContactPage = () => {
  useSEO({
    title: 'Contact - Raisy',
    description: 'Get in touch with the Raisy team.',
    keywords: 'contact, support, Raisy',
    ogTitle: 'Contact - Raisy',
    ogDescription: 'Get in touch with the Raisy team.',
    ogType: 'website',
    canonicalUrl: `https://${LEGAL_CONFIG.domain}${LEGAL_ROUTES.contact}`,
  });

  return (
    <PublicLayout>
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="mb-12 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            Contact {LEGAL_CONFIG.companyName}
          </h1>
          <p className="text-slate-500 dark:text-slate-400">
            We&apos;re here to help. Reach out to us with questions, feedback, or support requests.
          </p>
        </div>

        <div className="prose prose-slate dark:prose-invert max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-bold text-slate-900 dark:text-white">Email</h2>
            <p>
              For general inquiries and support, contact us at{' '}
              <a
                href={`mailto:${LEGAL_CONFIG.contactEmail}`}
                className="text-cyan-600 hover:text-cyan-700 dark:text-cyan-400 dark:hover:text-cyan-300"
              >
                {LEGAL_CONFIG.contactEmail}
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 dark:text-white">Mailing address</h2>
            <p>{LEGAL_CONFIG.companyAddress}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 dark:text-white">Response times</h2>
            <p>
              We aim to respond to support requests within two business days. For legal or privacy-related
              inquiries, please include relevant details so we can route your message to the right team.
            </p>
          </section>
        </div>
      </article>
    </PublicLayout>
  );
};
